#import "../fragments/account-attachments-fragment.graphql"

mutation RemoveAttachmentFromAccount($input: AccountFileRemoveInput!) {
    accountFileRemove(input: $input) {
        account {
            ...AccountAttachmentsFragment
        }
    }
}
